import { render, staticRenderFns } from "./ScaleConfiguration.vue?vue&type=template&id=005c1376"
import script from "./ScaleConfiguration.vue?vue&type=script&lang=js"
export * from "./ScaleConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports